import {createContext, useContext} from 'react'

/**
 * Row density inherited by menu/sidebar items — `true` renders the compact 32px
 * `dense` row (14px text) instead of the 36px default. `Sidebar dense` (or a
 * bare `MenuDensityProvider`) sets it once; `MenuItem` and `CollapsibleMenuItem`
 * read it and use it *unless* they pass their own `dense` prop, à la MUI's
 * `<List dense>`. Default `false` (comfortable).
 */
export const MenuDensityContext = createContext<boolean>(false)

/** Provide a density for all descendant menu items. */
export const MenuDensityProvider = MenuDensityContext.Provider

/** Read the inherited menu density (default `false`). */
export function useMenuDensity(): boolean {
  return useContext(MenuDensityContext)
}
